import React from 'react';
import { IFooter, IPageProps } from '@interfaces';
import { getDetectedDevice } from '../../../utils/device-detection';
import { Footer as FooterDesktop } from './footer-desktop-old/indexDefault';
import { Footer as FooterMobile } from './footer-mobile-old/Footer';
import { FooterSticky } from './footer-sticky/footer-sticky';

const defaultProps = {
    columnOne: { headline: '' },
    columnTwo: { headline: '' },
    columnThree: { headline: '' },
    columnFour: { headline: '' },
    columnFive: { headline: '' },
    socialMediaIcons: [],
    bottom: [],
    contactInfo: { jobButton: { targetUrl: '' } },
    contactForm: {
        phoneNumber: '<r hidden>phonelead</r>',
    },
    showFooterNewsletterInput: true, // @TODO: get from cookie
    isNewsletterNew: true,
};
const showFooterSticky = false; // @TODO: figureout if we need it, and when to show it

const Footer = (props: { footer: IFooter; footerMobile: any; pageProps: IPageProps }) => {
    const isDesktop = getDetectedDevice() === 'desktop';

    const type = props?.pageProps?.getLandingPage?.type || 'not-set';

    return isDesktop ? (
        <FooterDesktop {...{ ...defaultProps, ...props.footer, type }} />
    ) : (
        <>
            <FooterMobile
                {...({
                    footer: props.footerMobile ? props.footerMobile.bar : [],
                    seoFooter: props.footerMobile ? props.footerMobile : defaultProps,
                    type,
                } as any)}
            />
            {showFooterSticky && <FooterSticky />}
        </>
    );
};

export default Footer;
